import {
    GOALS,
    PROCESSES,
} from './editor.constants';

import { syncWebFormLabel } from '../elements/whens/webFormSubmitted/web.form.submitted.api';
import { syncInternalFormLabel } from '../elements/whens/internalFormSubmitted/internal.form.api';
import { syncNoteAppliedLabel } from '../elements/whens/noteApplied/note.applied.api';
import { syncEmailConfirmationLabel } from '../elements/thens/communications/legacyEmail/legacy.confirm.email.api';
import { syncUnlayerEmailLabel } from '../elements/thens/communications/unlayerEmail/unlayer.email.api';
import { syncLetterLabel } from '../elements/thens/communications/letter/letter.api';
import { syncFulfillmentLabel } from '../elements/thens/processes/fulfillment/fulfillment.api';

const labelSyncers = {
    [GOALS.GOAL_INTERNAL_FORM]: syncInternalFormLabel,
    [GOALS.GOAL_NOTE_APPLIED]: syncNoteAppliedLabel,
    [GOALS.GOAL_WEB_FORM]: syncWebFormLabel,
    [PROCESSES.PROCESS_EMAIL_CONFIRM]: syncEmailConfirmationLabel,
    [PROCESSES.PROCESS_FULFILLMENT_LIST]: syncFulfillmentLabel,
    [PROCESSES.PROCESS_LETTER]: syncLetterLabel,
    [PROCESSES.PROCESS_UNLAYER_EMAIL]: syncUnlayerEmailLabel,
};

export const syncLabel = async (cell) => {
    // goals are referenced by meta type, processes by cell style
    const sync = labelSyncers[cell?.meta?.metaType ?? cell?.meta?.style];

    if (sync) {
        return sync(cell);
    }

    return null;
};
